





























































import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SummaryCard extends Vue {
  @Prop({ required: true })
  private item!: any;

  get timeAgo() {
    return moment(this.item.createDate).format('DD/MM/YYYY HH:mm:ss');
  }

  private goToDetails() {
    this.$router.push(`/jobs/${this.item.id}`);
  }
}
